import { Screen } from '@epihub/web/src/routes/Screen';
import { bookCalendarRoute } from '@krishanmadan/core/src/routes/frontendRoutes';
import * as React from 'react';
import { Header } from '@krishanmadan/frontend/src/components/Header';
import { styled } from '@krishanmadan/frontend/src/theme/theme';
import { CalendarView } from '@krishanmadan/frontend/src/components/calendar/CalendarView';
import { CalendarHeader } from '@krishanmadan/frontend/src/components/calendar/CalendarHeader';

export const BookCalendarScreen = Screen(bookCalendarRoute, () => {
  return (
    <CalendarRoot>
      <FixedHeader headerHorizontalPadding={headerPadding}>
        <HeaderContainer>
          <StyledHeader />
        </HeaderContainer>
        <CalendarHeaderContainer>
          <CalendarHeader />
        </CalendarHeaderContainer>
      </FixedHeader>
      <ContentContainer>
        <CalendarView />
      </ContentContainer>
    </CalendarRoot>
  );
});

const HeaderContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const headerPadding = '3vw';

const StyledHeader = styled(Header)`
  margin-top: ${headerPadding};
`;

const CalendarHeaderContainer = styled.div`
  padding-top: 32px;
`;

// px - blur amount
const HEADER_BLUR_INTENSITY = 4;
// % - where the fade begins
const HEADER_FADE_START = 60;
// 0-1 - max background opacity
const HEADER_BG_OPACITY = 0.50;
const FixedHeader = styled.div<{ headerHorizontalPadding: string }>`
  // Mobile: relative position, scrolls with content
  position: relative;
  padding-left: ${({ headerHorizontalPadding }) => headerHorizontalPadding};
  padding-right: ${({ headerHorizontalPadding }) => headerHorizontalPadding};
  padding-bottom: 24px;

  // Desktop: fixed position with blur effect
  @media (min-width: 769px) {
    // Block pointer events on the background so when the user scrolls they can still interact with the calendar
    pointer-events: none;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    padding-bottom: 48px;
    backdrop-filter: blur(${HEADER_BLUR_INTENSITY}px);
    -webkit-backdrop-filter: blur(${HEADER_BLUR_INTENSITY}px);
    background: linear-gradient(
      to bottom,
      rgba(36, 36, 36, ${HEADER_BG_OPACITY}) 0%,
      rgba(36, 36, 36, ${HEADER_BG_OPACITY * 0.8}) 60%,
      rgba(36, 36, 36, ${HEADER_BG_OPACITY * 0.35}) 85%,
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      black 0%,
      black ${HEADER_FADE_START}%,
      transparent 100%
    );
    -webkit-mask-image: linear-gradient(
      to bottom,
      black 0%,
      black ${HEADER_FADE_START}%,
      transparent 100%
    );
  }
`;

const CalendarRoot = styled.div`
  position: relative;
  height: 100dvh;
  overflow-x: clip;
  overflow-y: auto;

  @media (min-width: 769px) {
    overflow: hidden;
  }
`;

const ContentContainer = styled.div`
  position: relative;
  padding-bottom: 48px;
  padding-left: 16px;
  padding-right: 16px;
  max-width: 100vw;
  overflow: visible;

  @media (min-width: 769px) {
    height: 100dvh;
    overflow-y: auto;
    overflow-x: clip;
    padding-top: 35dvh;
    padding-bottom: 96px;
    padding-left: 96px;
    padding-right: 96px;
    max-width: none;
  }
`;
